/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */
import React from 'react';

import { connect } from 'react-redux';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import ActionButtonLink from 'components/shared/Buttons/ActionButtonLink';
import { linkedBankAccountsLinks } from 'services/Externals';

import { ReactComponent as BankImage } from 'assets/BankImage.svg';
import { bool } from 'prop-types';
import { showZeroState } from 'state/linkedBankAccounts/LinkedBankAccountsSelectors';

const ZeroState = ({ showZeroState }) =>
  showZeroState ? (
    <PreferencesSection className="zero-state-card" fullBackground>
      <BankImage />
      <p className="zero-state-card-title">Link Your Bank Account</p>
      <p className="zero-state-card-copy">
        Connect to your bank account using your user name and password or by
        entering your routing and account numbers.
      </p>
      <ActionButtonLink
        href={linkedBankAccountsLinks.addNewBank}
        className="link-bank-accounts-link-button"
        id="link-new-bank-account-button"
        type="primary"
      >
        Add Bank Account
      </ActionButtonLink>
    </PreferencesSection>
  ) : null;

ZeroState.propTypes = {
  showZeroState: bool
};

ZeroState.defaultProps = {
  showZeroState: false
};

const mapStateToProps = (state) => ({
  showZeroState: showZeroState(state)
});

export default connect(mapStateToProps)(ZeroState);
